import React from "react";
import { Link } from "react-router-dom";
import Breadcrumbs from "../components/Breadcrumbs";
import AdminNav from "../components/AdminNav";
import RequireAdmin from "../components/RequireAdmin";

export default function AdminPage() {
  return (
    <RequireAdmin>
      <div
        data-testid="admin-index"
        className="mx-auto w-full max-w-[1200px] px-5 py-8 md:px-gutter md:py-10"
      >
        <Breadcrumbs items={[{ label: "Home", to: "/" }, { label: "Admin" }]} />
        <h1 className="mt-6 text-title-page text-ink-text">Admin</h1>
        <p className="mt-2 max-w-[64ch] text-body text-ink-muted">
          Behind-the-scenes controls for moderation, TCGplayer mapping,
          catalog + cache workers.
        </p>
        <AdminNav />
        <ul className="grid grid-cols-1 gap-4 sm:grid-cols-3">
          <AdminCard
            to="/admin/moderation"
            label="Moderation"
            desc="Approve or reject pending community showcases."
          />
          <AdminCard
            to="/admin/mappings"
            label="Price mappings"
            desc="Confirm which TCGplayer group each set maps to; trigger price refreshes."
          />
          <AdminCard
            to="/admin/catalog"
            label="Catalog & cache"
            desc="Rerun catalog import, monitor / restart the image-cache worker, reset errors."
          />
        </ul>
      </div>
    </RequireAdmin>
  );
}

function AdminCard({ to, label, desc }) {
  return (
    <li>
      <Link
        to={to}
        className="block rounded-card border border-ink-chip bg-ink-surface p-4 transition-colors duration-cc ease-cc-ease hover:border-ink-muted"
      >
        <div className="text-title-section text-ink-text">{label}</div>
        <p className="mt-1 text-meta text-ink-muted">{desc}</p>
      </Link>
    </li>
  );
}
